<template>
  <article class="blog-article__item group ">
    <div class="relative w-full">
      <BaseImage
        :src="imageSrc"
        :alt="imageAlt"
        class="aspect-[16/9] w-full rounded-sm bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]"
      />
      <div class="absolute inset-0 rounded-sm ring-1 ring-inset ring-gray-900/10" />
    </div>
    <div class="max-w-xl">
      <div class="mt-8 flex items-center gap-x-4 text-xs">
        <time :datetime="createdAt" class="text-gray-500">{{ formattedDate }}</time>
      </div>
      <div class="relative">
        <h3 class="mt-3 text-lg font-semibold leading-6 text-brand-black group-hover:text-brand-black/60">
          <span class="absolute inset-0" />
          {{ title }}
        </h3>
        <p class="mt-5 line-clamp-3 text-sm leading-6 text-gray-600">
          {{ introduction }}
        </p>
      </div>
      <!-- <div class="relative mt-8 flex items-center gap-x-4">
          <img
            src="https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=2&amp;w=256&amp;h=256&amp;q=80"
            alt=""
            class="h-10 w-10 rounded-full bg-gray-100"
          >
          <div class="text-sm leading-6">
            <p class="font-semibold text-gray-900">
              <a href="#">
                <span class="absolute inset-0" />
                Michael Foster
              </a>
            </p>
            <p class="text-gray-600">
              Co-Founder / CTO
            </p>
          </div>
        </div> -->
    </div>
  </article>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { dateFormat } from '~/lib/utils';
import BaseImage from '~/components/BaseImage.vue';

interface Props {
  title: string
  introduction: string
  createdAt?: string
  imageSrc?: string
  imageAlt?: string
}

const props = defineProps<Props>();

const formattedDate = computed(() => {
  return dateFormat(new Date(props.createdAt || ''), {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
});
</script>

<style scoped>
.blog-article__item {
  @apply flex flex-col items-start justify-between;
}
</style>
